<template>
      <!--新增切换语言按钮-->
      <div>
        <el-radio-group v-model="lan" @change="changeType" size="mini">
          <el-radio-button :label="'zh'">中</el-radio-button>
          <el-radio-button :label="'en'">En</el-radio-button>
        </el-radio-group>
      </div>
  </template>
  <script>
  export default {
    name: 'switchLang',
    data() 
    {
      return {lan:""}
    },
    beforeCreate() {
      // console.log(this.$i18n.locale ); 
      //zhconsole.log( localStorage.getItem('locale')); //zh
    },
    created() {
      this.lan=this.$i18n.locale  //$i18n在实例刚创建完成就有了，这不是$el要在mounted时才能取到
      // console.log(this.$i18n.locale ); //zhconsole.log( localStorage.getItem('locale')); //zh
    },
    methods:{
      changeType(type){
        // 此处做了语言选择记录，存在localStorage中，这里的作用只有一个当我重新请求页面
        //的时候先取localStorage的记录值
        // console.log('change type',type)
        localStorage.setItem('locale',type)
        this.$i18n.locale = type; // 修改页面需要显示的语言this.lan=this.$i18n.locale
        this.$bus.$emit('LANGUAGE_CHEANGED',type)
      }
    }
  }
  </script>
  
  <style>
  </style>
  


// WEBPACK FOOTER //
// src/components/common/i18n_button.vue